(() => {
  angular
    .module('app.campaign')
    .controller('CampaignReportPeriodController', CampaignReportPeriod);

  CampaignReportPeriod.$inject = [
    '$scope',
    '$interval',
    'CampaignManagerService',
  ];

  function CampaignReportPeriod(
    $scope,
    $interval,
    CampaignManagerService,
  ) {
    const vm = this;
    const integratedPeriodStartLimit = new Date(2018, 9, 1); // October 2018

    const currentUser = $('#current-user');
    const accountId = currentUser.data('company-id');

    vm.campaign = CampaignManagerService.getCampaignData();
    vm.minDate = vm.campaign.type === 'integrated' ? new Date(integratedPeriodStartLimit) : null;
    vm.isLimitUser = [1051, 1021].includes(accountId);
    vm.loading = vm.isLimitUser;

    const getWeeksRange = (date, migrationDate) => {
      const monday = new Date(date);
      monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7); // set to Monday of week
      monday.setDate(monday.getDate() - (7 * 12) - 1); // set to three month previous Sunday

      const mondayEnd = new Date(migrationDate);
      mondayEnd.setDate(mondayEnd.getDate() - (mondayEnd.getDay() + 6) % 7); // set to Monday of week
      mondayEnd.setDate(mondayEnd.getDate() - 7); // set to previous Monday
      const sunday = new Date(mondayEnd.getFullYear(), mondayEnd.getMonth(), mondayEnd.getDate() + 6); // create new date of sunday

      return {
        monday,
        sunday,
      };
    }

    const interval = $interval(() => {
      const storageDate = localStorage.getItem(`migrationDate${accountId}`);
      if (storageDate) {
        if (vm.isLimitUser) {
          const fixDate = '2024-03-04';

          const today = new Date();
          const migrationDate = new Date(fixDate);
          const weeksRange = getWeeksRange(today < migrationDate ? today : migrationDate, migrationDate);

          vm.minDate = weeksRange.monday;
          vm.maxDate = weeksRange.sunday;
          vm.loading = false;
        }

        $interval.cancel(interval);
      } else {
        vm.loading = false;
      }
    }, 500);

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
      campaign => {
        CampaignManagerService.setCampaignData(campaign);

        if (CampaignManagerService.isCampaignFieldChanged('start') ||
            CampaignManagerService.isCampaignFieldChanged('end')) {
          CampaignManagerService.showTechedgeNotification(campaign);
        }
      }, true);
  }
})();
